// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
// import { updateMe } from '../../apis/member';
// import { getMultilangs } from '../../components/common/Multilang';
// import MultiSelectModal from '../../components/MultiSelectModal';
// import CommonContext from '../../contexts/CommonContext';
// import MemberContext from '../../contexts/MemberContext';
import Footer from './Footer';
import Header from './Header';

const S = {
  Container: styled.div`
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 70px;
  `,
  Header: styled(Header)``,
  Body: styled.div`
    height: 100%;
    display: block;
  `,
  Footer: styled(Footer)`
    margin-top: auto;
  `,
}

const MainLayout: React.FC = ({
  children,
  ...props
}) => {
  // Need to update body overflow to hidden when notification scrolling.
  // Other scroller won't effect body scroller when body overflow is hidden.
  const bodyRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  // const member = useContext(MemberContext);
  // const common = useContext(CommonContext);
  // const [interestModalVisible, setInterestModalVisible] = useState(false);
  // const [expertiseModalVisible, setExpertiseModalVisible] = useState(false);

  // useEffect(() => {
  //   if (member.firstTime) {
  //     setInterestModalVisible(true);
  //   }
  // }, [member])

  return (
    <S.Body ref={bodyRef}>
      <S.Container {...props}>
        <S.Header bodyRef={bodyRef} />
        {children}
        {/* <MultiSelectModal
        limit={5}
        visible={interestModalVisible}
        title="Choose Interest"
        items={getMultilangs(common.interests)}
        selectedItems={member.interestIds}
        setSelectedItems={(interestIds) => {
          updateMe({
            interestIds,
            firstTime: false
          }).then(() => {
            member.update();
          })
          setInterestModalVisible(false);
          setExpertiseModalVisible(true);
        }}
        onClose={() => {
          updateMe({
            firstTime: false,
          }).then(() => {
            member.update();
          })
          setInterestModalVisible(false);
        }}
      />

      <MultiSelectModal
        limit={5}
        visible={expertiseModalVisible}
        title="Choose Expertise"
        items={getMultilangs(common.expertises)}
        selectedItems={member.expertiseIds}
        setSelectedItems={(expertiseIds) => {
          setExpertiseModalVisible(false);
          updateMe({
            expertiseIds,
            firstTime: false
          }).then(() => {
            member.update();
          })
        }}
        onClose={() => {
          setExpertiseModalVisible(false);
        }}
      /> */}
        { location.pathname.includes('examReview') ? null : <S.Footer /> }
      </S.Container>
    </S.Body>
  );
}

export { MainLayout as default, S }
